import { request } from "./api-require";
const API_URL = "/oms-operation-service/v1";
//分页申请列表
export const getMultichargeList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/page", data, config);
};
//审核一卡多充
export const auditMultiCharge = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/audit_multiCharge", data, config);
};
//分页查询公告内容
export const getNoticeList = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/page/notice", data, config);
};
//删除公告内容
export const delNotice = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/notice/info/delete/station/notice", data, config);
};
//添加系统公告内容
export const addNotice = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/add/system/notice", data, config);
};
//通过桩id获取充电枪信息
export const getStatGunKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/get/gun_by_pile", data, config);
};
//通过设备id获取桩id信息
export const getPileByDevice = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/get/pile_by_device", data, config);
};
export const getMonitorGunInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/gun/info", data, config);
};
//通过桩id获取费率详情信息
export const getFeeByPile = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/get_fee_by_pile", data, config);
};
//获取单个桩的枪口实时数据
export const getPileData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/pile/data", data, config);
};
//询费率下拉列表,费率feePkId - 费率名称
export const getFeeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/list", data, config);
};
// 获取充电站
export const getStaKvs = (data = {}, config = {}) => {
    return request(API_URL + "/stat/sta_kvs", data, config);
};
// 分页查询消费者日志
export const getCosumerLogList = (data = {}, config = {}) => {
    return request(API_URL + "/cosumer/log/page", data, config);
};
// 删除日志
export const delCosumerLog = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/cosumer/log/del", data, config);
};
// 重新消费
export const reconsumeCosumerLog = (data = {}, config = {}) => {
    return request(API_URL + "/cosumer/log/reconsume", data, config);
};
// 批量重新消费
export const batchReconsumeCosumerLog = (data = {}, config = {}) => {
    return request(API_URL + "/cosumer/log/batch_reconsume", data, config);
};
// 系统查询待办事项详情
export const getBacklogSysDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/backlog/sys/detail", data, config);
};
// 新增增值服务
export const addAccretionService = (data = {}, config = {}) => {
    return request(API_URL + "/opr/accretion/service/add", data, config);
};
// 删除增值服务
export const delAccretionService = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/accretion/service/del", data, config);
};
// 查询所有增值服务
export const getAccretionService = (data = {}, config = {}) => {
    return request(API_URL + "/opr/accretion/service/list", data, config);
};
// 修改增值服务
export const upAccretionService = (data = {}, config = {}) => {
    return request(API_URL + "/opr/accretion/service/upd", data, config);
};
// 站点规模 - 查看站点规模统计信息
export const getStaSizeStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/size/statistics", data, config);
};
// 站点规模 - 查看站点规模配置信息
export const getStaSizeConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/size/get", data, config);
};
// 站点规模 - 查看站点规模配置信息
export const updataStaSizeConfig = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/size/update", data, config);
};
//站点配置
export const getEntUserConfigSta = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/config_sta", data, config);
};
//已添加站点
export const getEntUserAlreadyExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/already_exist_sta", data, config);
};
//获取当前运营商所有站点集合
export const getCampaignStationList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/campaign/station/list", data, config);
};
//获取运营商配置信息
export const getCongifInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_congif_info", data, config);
};
//修改运营商分成配置信息
export const updOprConfigSettlementInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_config_settlement_info", data, config);
};
//获取运营商分成信息
export const getOprConfigSettlementInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_settlement_info", data, config);
};
//审核发票
export const auditOprInvoice = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/audit", data, config);
};
//发票已开具
export const getOprInvoiceDraw = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/draw", data, config);
};
//发票详情
export const getOprInvoiceDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/detail", data, config);
};
//发票审核信息
export const getOprInvoiceOperation = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/operation/detail", data, config);
};
//获取特约商户申请 信息
export const getSpecialMer = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/query", data, config);
};
//运营-充电桩键值对集合
export const getStatPileKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/pile_kvs", data, config);
};
//运营商 - 修改先充后付配置
export const updCreditCuthorityCongif = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_credit_cuthority_congif", data, config);
};
//获取标签列表
export const getOprTagSysPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/tag/sys/page", data, config);
};
//删除标签信息
export const deleteOprTagSysPage = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/tag/sys/delete", data, config);
};
//添加标签信息
export const addOprTagSysPage = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/tag/sys/add", data, config);
};
//分页查询标签关联站点信息
export const getOprTagBoundStaPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/tag/bound/sta/page", data, config);
};
//配置服务商信息
export const getUploadOperInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/save-config", data, config);
};
//获取服务商信息
export const getOperatorInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/list-config", data, config);
};
//分页获取问题反馈列表
export const getProblemFeedbackPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/page", data, config);
};
//服务商回复
export const getOperatorReply = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/reply-feed-back", data, config);
};
//查看问题反馈详情
export const getReplyDetail = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/detail", data, config);
};
